import { StringConstants } from "./StringConstants";

class UrlConstants extends StringConstants {
  DEV = false;
  STAGE = false;
  PROD = true;

  DEMO = false;

  url_prod = "https://glydegateway.com";
  url_dev = "https://dev.glydegateway.com";
  // url_dev = "http://localhost:3000";

  url = this.PROD ? this.url_prod : this.url_dev;

  environment: google.payments.api.Environment = this.PROD
    ? "PRODUCTION"
    : "TEST";

  socket_endpoint = this.PROD
    ? this.url_prod + "/"
    : (this.url_dev.includes("glyde")
        ? this.url_dev
        : "http://127.0.0.1:3000") + "/";

  appleRedirectURL = this.PROD
    ? "https://glydegateway.com/auth/login/apple?host=" +
      window.location.hostname
    : "https://dev.glydegateway.com/auth/login/apple?host=" +
      window.location.hostname;

  googleLogInClientId = this.PROD
    ? "535284248734-l353amprlobe0seh1bc1rapbteumlqvj.apps.googleusercontent.com"
    : "535284248734-l353amprlobe0seh1bc1rapbteumlqvj.apps.googleusercontent.com";

  squareAppID = this.PROD
    ? "sq0idp-IGJtjIxY52LS_Ne2ifvBhQ"
    : "sandbox-sq0idb-TB97JawR0WMhvdRTvXTMaQ";

  // Routes

  landingViewPath = "/";
  authViewPath = "/auth";
  menuViewPath = "/menu";
  itemViewPath = "/item";
  loginViewPath = "/login";
  preLoginViewPath = "/prelogin";
  ordersViewPath = "/orders";
  tabOrdersViewPath = "/taborders";
  thankYouViewPath = "/thankyou";
  paymentViewPath = "/payment";
  cartViewPath = "/cart";
  paymentMethodViewPath = "/select-payment-method";
  restaurantClosedViewPath = "/restaurant-closed";
  tableCheckInputViewPath = "/table-check-input";
  apple_developer_merchantid_domain_association =
    "/.well-known/apple-developer-merchantid-domain-association";
  apple_developer_merchantid_domain_association_txt =
    "/.well-known/apple-developer-merchantid-domain-association.txt";

  // Endpoints Initials

  restaurant = "restaurant";
  menu = "menu";
  promo = "promo";
  user = "user";
  tab = "tab";
  session = "session";
  webSession = "webSession";
  analytics = "analytics";
  order = "order";
  apple = "apple";
  paymentGateway = "pg";
  auth = "auth";

  // Auth-Old APIs
  GOOGLELOGIN = `${this.url}/${this.auth}/login/google`;
  APPLELOGIN = `${this.url}/${this.auth}/login/apple`;
  EXPRESSCHECKOUTCREATEUSERDEMO = `${this.url}/${this.auth}/login/demo/guest`;

  // Auth APIs
  CREATEGUESTUSER = `${this.url}/${this.auth}/login/guest`; // Done
  VERIFYOTP = `${this.url}/${this.auth}/otp/verify`; // Done
  RESENDOTP = `${this.url}/${this.auth}/otp/resend`; // Done
  REFRESHTOKEN = `${this.url}/${this.auth}/refresh/token`; // Done

  // Menu APIs
  GETITEM = `${this.url}/${this.menu}/item`; // Done
  SEARCHITEM = `${this.url}/${this.menu}/item/search`; // Done
  GETMENUBYID = `${this.url}/${this.menu}`; // Done
  GETFREQUENTLYORDEREDITEMS = `${this.url}/${this.menu}/item/recommend`; // Done
  VALIDATEITEMS = `${this.url}/${this.menu}/validate/items`; // Done
  VALIDATEITEMSANDMODIFIERS = `${this.url}/${this.menu}/validate/items/modifiers`; // Done

  // WebSession APIs
  CREATESESSION = `${this.url}/${this.webSession}/create`; // Done
  CHECKSESSIONACTIVE = `${this.url}/${this.webSession}/isActive`; // Done
  CALLWAITER = `${this.url}/${this.webSession}/call/waiter`; // Done
  GETSESSIONFORTABSCREEN = `${this.url}/${this.webSession}/items`; // Done
  SENDRECEIPT = `${this.url}/${this.webSession}/send/receipt`; // Done

  // Analytics APIS
  UPDATECLICKCOUNT = `${this.url}/${this.analytics}/click/count`; // Not in Use
  ERRORBOUNDARY = `${this.url}/${this.analytics}/error/white-screen`; // Done
  FETCH_SURVEY_LINK = `${this.url}/${this.analytics}/survey`; // Done
  ADDRATING = `${this.url}/${this.analytics}/session/rating`; // Done

  // Session APIs
  SPLITPAYAUTH = `${this.url}/${this.session}/splitpay/auth`; // Done
  SPLITPAYCHECKOUT = `${this.url}/${this.session}/splitpay/checkout`; // Done
  FETCHACTIVECARDSONTABLE = `${this.url}/${this.session}/available/card/adoption`; // Done
  ADOPTACARD = `${this.url}/${this.session}/adopt/card`; // Done
  CHECKPAYMENTMETHOD = `${this.url}/${this.session}/register/card`; // Done
  VERIFYCARD = `${this.url}/${this.session}/verify/card`; // Done
  SESSION_ITEM_PRICE = `${this.url}/${this.session}/item-price`; // Append /{table}/{guid}

  // Restaurant APIs
  INCOMINGRESTAURANT = `${this.url}/${this.restaurant}`; // Done
  RESTAURANT_ASSETS = `${this.url}/${this.restaurant}/assets`; // New endpoint for restaurant branding (append /:restaurantId)
  RESTAURANT_REDIRECT = `${this.url}/${this.restaurant}/redirect`; // New endpoint for table/check verification
  SENDDINEINURLTOUSER = `${this.url}/${this.restaurant}/send/link/user`; // Not in Use
  CHECKPROMOS = `${this.url}/${this.restaurant}/promo/available`; // Not in Use

  // Order APIs
  ADDITEMS = `${this.url}/${this.order}/${this.tab}/add/item`; // Done
  TABSESSIONTAXANDFEESSPLITPAY = `${this.url}/${this.order}/totals`; // Done

  // Apple APIs
  APPLEPAYMERCHANTVALIDATION = `${this.url}/${this.apple}/validate/merchant`; // Done

  // Users APIs
  INCOMINGUSER = `${this.url}/${this.user}/info`;

  // Loyalty APIs
  LOYALTY_SIGNUP = `${this.url}/loyalty/signup`;
  LOYALTY_LOGIN = `${this.url}/loyalty/login`;
  LOYALTY_FORGOT_PASSWORD = `${this.url}/loyalty/forgot-password`;

  // Payment Processor
  PUBLIC_KEY = `${this.url}/${this.paymentGateway}/encryption/key/public`;
  GETPAYMENTPROCESSOR = `${this.url}/${this.paymentGateway}/payment/processor`;

  idempEndpoints = [this.SPLITPAYAUTH, this.SPLITPAYCHECKOUT];

  // PostHog
  POSTHOG_IGNORED_APIS = [this.CHECKSESSIONACTIVE, this.SESSION_ITEM_PRICE];
}

let urls = new UrlConstants();
export default urls;
